import { Component, OnInit } from '@angular/core';
import { Datalistviewcolumn } from 'src/app/shared/datalistview/columns/datalistviewcolumn';

@Component({
    selector: 'app-datafeeds',
    templateUrl: './datafeeds.component.html',
    styleUrls: ['./datafeeds.component.scss'],
    standalone: false
})
export class DataFeedsComponent implements OnInit {

  constructor() { }

  public Columns: Array<Datalistviewcolumn> = [
    new Datalistviewcolumn("Description", "Description"),
    new Datalistviewcolumn("Structure", "StructureName"),
    new Datalistviewcolumn("Feed Type", "FeedType"),
    new Datalistviewcolumn("Feed Target", "FeedTarget"),
  ];

  public SubSets: Array<string> = [
    "Spaces", "Regions", "Kinesis", "Kinesis Spaces", "Kinesis Regions", "SFTP", "SFTP Spaces", "SFTP Regions"
  ];

  ngOnInit(): void {
  }
} 
